import {postRequest} from '../../../../../middlewares/api/actions';
import {getCalcTableColumnPreviewUrl} from '../../../../../constants/urls';

export const FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_CALCULATED_COLUMN_VALUES_GET = 'FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_CALCULATED_COLUMN_VALUES_GET';
export const FILE_MAPPING_WIZARD_CALCULATED_COLUMN_VALUE_LIST_SHOW = 'FILE_MAPPING_WIZARD_CALCULATED_COLUMN_VALUE_LIST_SHOW';
export const FILE_MAPPING_WIZARD_CALCULATED_COLUMN_VALUE_LIST_HIDE = 'FILE_MAPPING_WIZARD_CALCULATED_COLUMN_VALUE_LIST_HIDE';

export const getFileMappingWizardCalcColumnValueListColValues = (colName, pageNum, pageSize, filterTable, sortCols, sortByDesc, tableName, hasAlias) =>
  postRequest(
    FILE_MAPPING_WIZARD_COLUMN_VALUE_LIST_CALCULATED_COLUMN_VALUES_GET,
    getCalcTableColumnPreviewUrl(tableName),
    {
      SelCols: [colName],
      PageNum: pageNum,
      PageSize: pageSize,
      FilterTable: filterTable,
      SortCols: sortCols,
      SortByDesc: sortByDesc,
      HasCalculatedField: true,
      HasAliasField: hasAlias
    }
  );

export const showFileMappingWizardCalculatedColumnValueList = (colName, hasAlias) => ({
  type: FILE_MAPPING_WIZARD_CALCULATED_COLUMN_VALUE_LIST_SHOW,
  colName,
  hasAlias
});

export const hideFileMappingWizardCalculatedColumnValueList = () => ({
  type: FILE_MAPPING_WIZARD_CALCULATED_COLUMN_VALUE_LIST_HIDE
});
